import HomeIcon from "@mui/icons-material/Home";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import Customer from "./meefood/pages/customer/Customer";
import CustomerForm from "./meefood/pages/customer/CustomerForm";
import BrandList from "./meefood/pages/brand/BrandList";
import BrandForm from "./meefood/pages/brand/BrandForm";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import CategoryIcon from "@mui/icons-material/Category";
import ProductCategory from "./meefood/pages/productCategory/ProductCategory";
import ProductCategoryForm from "./meefood/pages/productCategory/ProductCategoryForm";
import ProductMaster from "./meefood/pages/productMaster/ProductMaster";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ProductMasterForm from "./meefood/pages/productMaster/ProductMasterForm";
import TodayProduct from "./meefood/pages/todayProduct/TodayProduct";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import TodayProductForm from "./meefood/pages/todayProduct/TodayProductForm";
import EmployeeTabel from "./meefood/pages/employee/EmployeeTabel";
import EmployeeForm from "./meefood/pages/employee/EmployeeForm";
import PersonIcon from "@mui/icons-material/Person";
import { MdAdminPanelSettings } from "react-icons/md";
import RoleCreateForm from "./meefood/pages/role/roleCreate/RoleCreateForm";
import RolePermission from "./meefood/pages/role/rolePermission/RolePermission";
import RoleCreateTabel from "./meefood/pages/role/roleCreate/RoleCreateTabel";
import SignIn from "./meefood/pages/authentication/signin/SignIn";
import CompenyMaster from "./meefood/pages/compneyMaster/CompenyMaster";
import CompenyMasterForm from "./meefood/pages/compneyMaster/CompenyMasterForm";
import PaymentBalanceMaster from "./meefood/pages/paymentBalance/PaymentBalanceMaster";
import PaymentBalanceForm from "./meefood/pages/paymentBalance/PaymentBalanceForm";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import NewCustomer from "./meefood/pages/NewCustomer";
import NewCustomerForm from "./meefood/pages/NewCustomer/component/NewCustomerForm";
import SalesOrderList from "./meefood/pages/salesOrder/salesOrderList";
import SalesOrderForm from "./meefood/pages/salesOrder/salesOrderForm";
import PaymentFollow from "./meefood/pages/report/Payment/PaymentFollow";
import ViewPaymentFollow from "./meefood/pages/report/Payment/ViewPaymentFollow";
import SalesOrder from "./meefood/pages/report/Sales/SalesOrder";
import SalesOrderView from "./meefood/pages/report/Sales/SalesOrderView";
import RealtimeInventory from "./meefood/pages/report/RealTimeInventory.js/RealtimeInventory";
import OutstandingBalance from "./meefood/pages/report/OutstandingBalance/OutstandingBalance";
import RealtimeInventoryView from "./meefood/pages/report/RealTimeInventory.js/RealtimeInventoryView";
import OutstandingBalanceView from "./meefood/pages/report/OutstandingBalance/OutstandingBalanceView";
import Dashboard from "./meefood/pages/dashBoard";
import ViewPaymentBalance from "./meefood/pages/paymentBalance/ViewPaymentBalance";
import PaymentCollectionForm from "./meefood/pages/paymentCollection/paymentCollectionForm/paymentCollectionForm";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import EngineeringIcon from "@mui/icons-material/Engineering";
import TodoListTable from "./meefood/pages/todo";
import ListAltIcon from "@mui/icons-material/ListAlt";
import TodoForm from "./meefood/pages/todo/todoForm";
import BalanceIcon from "@mui/icons-material/Balance";
import CompetitorAnalysis from "./meefood/pages/competitorAnalysis";
import CompetitorAnalysisForm from "./meefood/pages/competitorAnalysis/form";
import ReturnsManagement from "./meefood/pages/returnsManagement";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import SlowmovingproductList from "./meefood/pages/slowmovingproducts/slowmovingproductslist";
import SlowmovingProductsForm from "./meefood/pages/slowmovingproducts/slowmovingproductform";
import ManageComplaints from "./meefood/pages/manageComplaints";
import ManageComplaintsForms from "./meefood/pages/manageComplaints/form";
import ReturnForm from "./meefood/pages/returnsManagement/returnsForm/ReturnForm";
import ProductDisplayCompliance from "./meefood/pages/productDisplayCompliance/productdisplaycompliancelist";
import SamplesAndFeedback from "./meefood/pages/samplesAndFeedback";
import SampleForm from "./meefood/pages/samplesAndFeedback/sampleForm";
import CustomerTarget from "./meefood/pages/Target/CustomerTarget/CustomerTarget";
import Notification from "./meefood/pages/Notification/Notification";
import ReconcilationRemark from "./meefood/pages/productDisplayCompliance/reconcileandremark";
import {
  ContactSupport,
  DeliveryDining,
  Description,
  RateReview,
} from "@mui/icons-material";
import ManageDeliveriesList from "./meefood/pages/manageDeliveries";
import DeliveryForm from "./meefood/pages/manageDeliveries/deliveryForm";
import SampleFeedback from "./meefood/pages/report/SampleFeedback/SampleFeedback";
import StockExpiry from "./meefood/pages/report/StockExpiry/StockExpiry";
import DeliveryReport from "./meefood/pages/report/DeliveryReport/DeliveryReport";
import NewCustomerProposal from "./meefood/pages/report/NewCustomerProposal/NewCustomerProposal";
import ReturnsReport from "./meefood/pages/report/ReturnsReport/ReturnsReport";
import ExecutiveWiseTarget from "./meefood/pages/Target/ExecutiveWiseTarget/ExecutiveWiseTarget";
import SlowMovingItems from "./meefood/pages/report/SlowMovingItems/SlowMovingItems";
import CompetitorAnalysisReport from "./meefood/pages/report/CompetitorAnalysis/competitorAnalysis";
import MerchandiseCompliance from "./meefood/pages/report/MerchandiseCompliance/merchandiseCompliance";
import TargetCollection from "./meefood/pages/Target/TargetCollection/Targetcollection";
import PdfPage from "./meefood/pages/manageDeliveries/pdf";
import { PiTargetBold } from "react-icons/pi";
import Groups3Icon from "@mui/icons-material/Groups3";
import CustomerMaster from "./meefood/pages/CustomerMaster/CustomerMaster";
import CustomerMasterForm from "./meefood/pages/CustomerMaster/CustomerMasterForm";
import { RiMapPinUserFill } from "react-icons/ri";
import DeliveryMapView from "./meefood/pages/deliveryMapView";
import ProductDisplayComplianceForm from "./meefood/pages/productDisplayCompliance/newUi/form";
import Page from "./meefood/pages/privacyPolicy/pages";
import DepartmentMaster from "./meefood/pages/departmentMaster/DepartmentMaster";
import DepartmentMasterForm from "./meefood/pages/departmentMaster/DepartmentMasterForm";

const routes = [
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Sign in",
        key: "sign-in",
        route: "/sign-in",
        component: <SignIn />,
      },
    ],
  },
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Privacy Policy",
        key: "privacy-policy",
        route: "/privacy-policy",
        component: <Page />,
      },
    ],
  },

  {
    type: "collapse",
    icon: <HomeIcon />,
    name: "DashBoard",
    key: "dashboard",
    route: "/dashboard",
    access: "admin",
    module: "Dashboard Screen",
    component: <Dashboard />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    icon: <EngineeringIcon />,
    name: "Master",
    key: "master",
    module: "Company Screen",
    protected: true,
    collapse: [
      {
        name: "Company Master",
        key: "company-master",
        route: "master/company-master",
        module: "Company Screen",
        component: <CompenyMaster />,
        protected: true,
      },
      {
        name: "Product Master",
        key: "product-masters",
        route: "/product-masters",
        module: "Product Master Screen",
        component: <ProductMaster />,
        protected: true,
      },
      {
        name: "Customer Master",
        key: "customer-master",
        route: "master/customer-master",
        module: "Customer Master Screen",
        component: <CustomerMaster />,
        protected: true,
      },
      {
        name: "Department Master",
        key: "department-masters",
        route: "/department-masters",
        module: "Department Master Screen",
        component: <DepartmentMaster />,
        protected: true,
      },
    ],
  },
  {
    type: "AddCompenyMaster",
    key: "add-compeny-master",
    module: "Company Screen",
    route: "/master/company-master/add-company-master",
    component: <CompenyMasterForm />,
    protected: true,
  },
  {
    type: "EditCompenyMaster",
    key: "edit-compeny-master",
    module: "Company Screen",
    route: "/master/company-master/edit-company-master",
    component: <CompenyMasterForm />,
    protected: true,
  },
  {
    type: "Notification",
    key: "Notification",
    module: "Company Screen",
    route: "/notification",
    component: <Notification />,
    protected: true,
  },
  {
    type: "ViewCompenyMaster",
    key: "view-compeny-master",
    module: "Company Screen",
    route: "/master/company-master/view-company-master",
    component: <CompenyMasterForm />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Identity",
    key: "role",
    module: "Role Screen",
    access: "admin",
    icon: <MdAdminPanelSettings />,
    protected: true,
    collapse: [
      {
        name: "Role Create",
        key: "rolecreate",
        route: "role/rolecreate",
        module: "Role Screen",
        access: "admin",

        component: <RoleCreateTabel />,
        protected: true,
      },
      {
        name: "Role Permission",
        key: "role-permission",
        route: "role/role-permission",
        module: "Role Screen",

        access: "admin",
        component: <RolePermission />,
        protected: true,
      },
    ],
  },
  {
    type: "AddRole",
    key: "add-role",
    route: "role/rolecreate/add-role",
    module: "Role Screen",
    component: <RoleCreateForm />,
    protected: true,
  },
  {
    type: "EditRole",
    key: "edit-role",
    route: "role/rolecreate/edit-role",
    module: "Role Screen",
    component: <RoleCreateForm />,
    protected: true,
  },
  {
    type: "ViewRole",
    key: "view-role",
    route: "role/rolecreate/view-role",
    module: "Role Screen",
    component: <RoleCreateForm />,
    protected: true,
  },

  {
    type: "collapse",
    icon: <PersonIcon />,
    name: "Employee",
    key: "employee",
    route: "/employee",
    access: "admin",
    module: "Employee Screen",

    component: <EmployeeTabel />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddEmployee",
    key: "add-employee",
    route: "/employee/add-employee",
    module: "Employee Screen",
    access: "admin",

    component: <EmployeeForm />,
    protected: true,
  },
  {
    type: "EditEmployee",
    key: "edit-employee",
    route: "/employee/edit-employee",
    module: "Employee Screen",

    access: "admin",
    component: <EmployeeForm />,
    protected: true,
  },
  {
    type: "ViewEmployee",
    key: "view-employee",
    route: "/employee/view-employee",
    module: "Employee Screen",
    component: <EmployeeForm />,
    protected: true,
    access: "admin",
  },
  {
    type: "collapse",
    icon: <BrandingWatermarkIcon />,
    name: "Brand",
    key: "brand",
    route: "/brand",
    module: "Brand Screen",
    component: <BrandList />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddBrand",
    key: "add-brand",
    route: "/brand/add-brand",
    module: "Brand Screen",
    component: <BrandForm />,
    protected: true,
  },
  {
    type: "EditBrand",
    key: "edit-brand",
    route: "/brand/edit-brand",
    module: "Brand Screen",
    component: <BrandForm />,
    protected: true,
  },
  {
    type: "ViewBrand",
    key: "view-brand",
    route: "/brand/view-brand",
    module: "Brand Screen",
    component: <BrandForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <CategoryIcon />,
    name: "Product Category",
    key: "product-category",
    route: "/product-category",
    module: "Product Category Screen",
    component: <ProductCategory />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddProductCategory",
    key: "add-product-category",
    route: "/product-category/add-product-category",
    module: "Product Category Screen",
    component: <ProductCategoryForm />,
    protected: true,
  },
  {
    type: "EditProductCategory",
    key: "edit-product-category",
    route: "/product-category/edit-product-category",
    module: "Product Category Screen",
    component: <ProductCategoryForm />,
    protected: true,
  },
  {
    type: "ViewProductCategory",
    key: "view-product-category",
    route: "/product-category/view-product-category",
    module: "Product Category Screen",
    component: <ProductCategoryForm />,
    protected: true,
  },

  {
    type: "AddProductMaster",
    key: "add-product-master",
    route: "/product-masters/add-product-master",
    module: "Product Master Screen",
    component: <ProductMasterForm />,
    protected: true,
  },
  {
    type: "EditProductMaster",
    key: "edit-product-master",
    route: "/product-masters/edit-product-master",
    module: "Product Master Screen",
    component: <ProductMasterForm />,
    protected: true,
  },
  {
    type: "ViewProductMaster",
    key: "view-product-master",
    route: "/product-masters/view-product-master",
    module: "Product Master Screen",
    component: <ProductMasterForm />,
    protected: true,
  },
  {
    type: "AddDepartmentMaster",
    key: "add-department-master",
    route: "/department-masters/add-department-master",
    module: "Product Master Screen",
    component: <DepartmentMasterForm />,
    protected: true,
  },
  {
    type: "EditDepartmentMaster",
    key: "edit-department-master",
    route: "/department-masters/edit-department-master",
    module: "Product Master Screen",
    component: <DepartmentMasterForm />,
    protected: true,
  },
  {
    type: "ViewDepartmentMaster",
    key: "view-department-master",
    route: "/department-masters/view-department-master",
    module: "Product Master Screen",
    component: <DepartmentMasterForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <ProductionQuantityLimitsIcon />,
    name: "Today's Products",
    key: "todays-products",
    route: "/todays-products",
    module: "Today Product Screen",
    component: <TodayProduct />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddTodayProduct",
    key: "add-today-product",
    route: "/todays-products/add-today-product",
    module: "Today Product Screen",
    component: <TodayProductForm />,
    protected: true,
  },
  {
    type: "EditTodayProduct",
    key: "edit-today-product",
    route: "/todays-products/edit-today-product",
    module: "Today Product Screen",
    component: <TodayProductForm />,
    protected: true,
  },
  {
    type: "ViewTodayProduct",
    key: "view-today-product",
    route: "/todays-products/view-today-product",
    module: "Today Product Screen",
    component: <TodayProductForm />,
    protected: true,
  },

  {
    type: "AddCustomerMaster",
    key: "add-customer-master",
    route: "/master/customer-master/add-customer-master",
    module: "Customer Master Screen",

    component: <CustomerMasterForm />,
    protected: true,
  },
  {
    type: "EditCustomerMaster",
    key: "edit-customer-master",
    route: "/master/customer-master/edit-customer-master",
    module: "Customer Master Screen",

    component: <CustomerMasterForm />,
    protected: true,
  },
  {
    type: "ViewCustomerMaster",
    key: "view-customer-master",
    route: "/master/customer-master/view-customer-master",
    module: "Customer Master Screen",

    component: <CustomerMasterForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <SupportAgentIcon />,
    name: "Visit Customer",
    key: "visit-customer",
    route: "/visit-customer",
    module: "Visit Customer Screen",
    component: <Customer />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "AddVisitCustomer",
    key: "add-customer",
    route: "/visit-customer/add-customer",
    module: "Visit Customer Screen",
    component: <CustomerForm />,
    protected: true,
  },

  {
    type: "EditVisitCustomer",
    key: "edit-customer",
    route: "/visit-customer/edit-customer",
    module: "Visit Customer Screen",
    component: <CustomerForm />,
    protected: true,
  },
  {
    type: "ViewVisitCustomer",
    key: "view-customer",
    route: "/visit-customer/view-customer",
    module: "Visit Customer Screen",
    component: <CustomerForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <SupervisorAccountIcon />,
    name: "New Customer",
    key: "newcustomer",
    route: "/newcustomer",
    module: "New Customer Screen",
    component: <NewCustomer />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "AddNewCustomer",
    key: "add-new-customer",
    module: "New Customer Screen",
    route: "/newcustomer/add-new-customer",
    component: <NewCustomerForm />,
    protected: true,
  },

  {
    type: "EditNewCustomer",
    key: "edit-new-customer",
    module: "New Customer Screen",
    route: "/newcustomer/edit-new-customer",
    component: <NewCustomerForm />,
    protected: true,
  },
  {
    type: "ViewNewCustomer",
    key: "view-new-customer",
    module: "New Customer Screen",
    route: "/newcustomer/view-new-customer",
    component: <NewCustomerForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <ShoppingCartIcon />,
    name: "Sales Order",
    key: "sales-order",
    route: "/sales-order",
    module: "Sales Order Screen",

    component: <SalesOrderList />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "EditSalesOrder",
    key: "edit-sales-order",
    route: "/sales-order/edit-sales-order",
    component: <SalesOrderForm />,
    module: "Sales Order Screen",

    protected: true,
  },
  {
    type: "AddSalesOrder",
    key: "add-sales-order",
    route: "/sales-order/add-sales-order",
    component: <SalesOrderForm />,
    module: "Sales Order Screen",

    protected: true,
  },
  {
    type: "ViewSalesOrder",
    key: "view-sales-order",
    route: "/sales-order/view-sales-order",
    module: "Sales Order Screen",

    component: <SalesOrderForm />,
    protected: true,
  },

  {
    type: "collapse",
    icon: <AccountBalanceWalletIcon />,
    name: "Payment Balance",
    key: "paymentBalance",
    route: "/paymentBalance",
    module: "Payment Balance Screen",
    component: <PaymentBalanceMaster />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "PaymentBalance-Form",
    key: "PaymentBalanceForm",
    route: "/paymentBalance/paymentBalanceForm",
    module: "Payment Balance Screen",
    component: <PaymentBalanceForm />,
    protected: true,
  },
  {
    type: "ViewPaymentBalance",
    key: "ViewPaymentBalance",
    route: "/paymentBalance/ViewPaymentBalance",
    module: "Payment Balance Screen",
    component: <ViewPaymentBalance />,
    protected: true,
  },
  {
    type: "payment-Collection",
    key: "payment-Collection",
    route: "/paymentBalance/payment-Collection",
    module: "Payment Balance Screen",
    component: <PaymentCollectionForm />,
    protected: true,
  },

  {
    type: "collapse",
    icon: <ListAltIcon />,
    name: "To Do",
    key: "todo",
    route: "/todo",
    module: "To Do Screen",
    component: <TodoListTable />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/todo/form",
    module: "To Do Screen",
    component: <TodoForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <BalanceIcon />,
    name: "Competitor Analysis",
    key: "competitor-Analysis",
    route: "/competitor-Analysis",
    module: "Competitor Analysis Screen",
    component: <CompetitorAnalysis />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/competitor-Analysis/form",
    module: "Competitor Analysis Screen",
    component: <CompetitorAnalysisForm />,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/slow-moving-products/form",
    module: "Slow Moving Products Screen",
    component: <SlowmovingProductsForm />,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/product-compliance/form",
    module: "Product Display Compliance Screen",
    component: <ProductDisplayComplianceForm />,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/product-compliance/reconcile",

    component: <ReconcilationRemark />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <AssignmentReturnedIcon />,
    name: "Returns Management",
    key: "returns-management",
    route: "/returns-management",
    module: "Returns Management Screen",
    component: <ReturnsManagement />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/returns-management/return-Form",
    module: "Returns Management Screen",
    component: <ReturnForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <RateReview />,
    name: "Samples & Feedback",
    key: "samples-and-feedback",
    route: "/samples-and-feedback",
    module: "Sample and Feedback Screen",
    component: <SamplesAndFeedback />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/samples-and-feedback/sample-Form",
    module: "Sample and Feedback Screen",
    component: <SampleForm />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <AssignmentReturnedIcon />,
    name: "Slow Moving Products",
    key: "slow-moving-products",
    route: "/slow-moving-products",
    module: "Slow Moving Products Screen",
    component: <SlowmovingproductList />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    icon: <ContactSupport />,
    name: "Manage Complaints",
    key: "manage-complaints",
    route: "/manage-complaints",
    module: "Manage Complaints Screen",
    component: <ManageComplaints />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/manage-complaints/form",
    module: "Manage Complaints Screen",
    component: <ManageComplaintsForms />,
    protected: true,
  },
  {
    type: "collapse",
    icon: <Description />,
    name: "Product Compliance",
    key: "product-compliance",
    route: "/product-compliance",
    module: "Product Display Compliance Screen",
    component: <ProductDisplayCompliance />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    icon: <DeliveryDining />,
    name: "Manage Deliveries",
    module: "Manage Deliveries Screen",
    key: "Manage-Deliveries",

    route: "/Manage-Deliveries",
    component: <ManageDeliveriesList />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/Manage-Deliveries/Delivery-Form",
    module: "Manage Deliveries Screen",
    component: <DeliveryForm />,
    protected: true,
  },
  {
    type: "form",
    key: "form",
    route: "/Manage-Deliveries/Delivery-Receipt",

    module: "Manage Deliveries Screen",
    component: <PdfPage />,
    protected: true,
  },

  {
    type: "collapse",
    icon: <RiMapPinUserFill />,
    name: "Delivery Map",
    key: "delivery-map",
    route: "/delivery-map",
    module: "Delivery MapView Screen",

    component: <DeliveryMapView />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    module: "Reports Screen",
    icon: <MdAdminPanelSettings />,
    protected: true,

    collapse: [
      {
        name: "Realtime Inventory",
        key: "realtime-inventory",
        route: "/realtime-inventory",
        module: "Reports Screen",
        component: <RealtimeInventory />,
        protected: true,
      },
      {
        name: "Outstanding Balance",
        key: "outstandingbalance",
        route: "/outstanding-balance",
        module: "Reports Screen",
        component: <OutstandingBalance />,
        protected: true,
      },
      {
        name: "Payment Follow",
        key: "paymentfollow",
        route: "/payment-follow",
        module: "Reports Screen",
        component: <PaymentFollow />,
        protected: true,
      },
      {
        name: "Sales Order",
        key: "salesorder",
        route: "/sales-order-report",
        module: "Reports Screen",
        component: <SalesOrder />,
        protected: true,
      },
      {
        name: "Sample Feedback",
        key: "SampleFeedback",
        route: "/sample-feedback",
        module: "Reports Screen",
        component: <SampleFeedback />,
        protected: true,
      },
      {
        name: "Stock Expiry",
        key: "StockExpiry",
        route: "/stock-expiry",
        module: "Reports Screen",
        component: <StockExpiry />,
        protected: true,
      },
      {
        name: "Delivery Report",
        key: "DeliveryReport",
        route: "/delivery-report",
        module: "Reports Screen",
        component: <DeliveryReport />,
        protected: true,
      },
      {
        name: "New Customer Proposal",
        key: "NewCustomerProposal",
        route: "/new-customer-proposal",
        module: "Reports Screen",
        component: <NewCustomerProposal />,
        protected: true,
      },

      {
        name: "Returns Report",
        key: "ReturnsReport",
        route: "/returns-report",
        module: "Reports Screen",
        component: <ReturnsReport />,
        protected: true,
      },
      {
        name: "Slow Moving Items",
        key: "SlowMovingItems",
        route: "/slow-moving-items",
        module: "Reports Screen",
        component: <SlowMovingItems />,
        protected: true,
      },
      {
        name: "Merchandise Compliance",
        key: "MerchandiseCompliance",
        route: "/merchandise-compliance-report",
        module: "Reports Screen",
        component: <MerchandiseCompliance />,
        protected: true,
      },
      {
        name: "Competitor Analysis",
        key: "CompetitorAnalysisReport",
        route: "/competitor-analysis-report",
        module: "Reports Screen",
        component: <CompetitorAnalysisReport />,
        protected: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Target",
    key: "target",
    module: "Targets Screen",
    icon: <PiTargetBold />,
    protected: true,
    collapse: [
      {
        name: "Customer Target",
        key: "customer-target",
        route: "/customer-target",
        module: "Targets Screen",
        component: <CustomerTarget />,
        protected: true,
      },
      {
        name: "Executive Wise Target",
        key: "executive-wise-target",
        route: "/executive-wise-target",
        module: "Targets Screen",
        component: <ExecutiveWiseTarget />,
        protected: true,
      },
      {
        name: "Target Collection",
        key: "target-collection",
        route: "/target-collection",
        module: "Targets Screen",
        component: <TargetCollection />,
        protected: true,
      },
    ],
  },
  {
    type: "View Payment Follow",
    key: "view-payment-follow",
    route: "/payment-follow/view-payment-follow",
    module: "Reports Screen",
    component: <ViewPaymentFollow />,
    protected: true,
  },
  {
    key: "view-sales-order",
    route: "/sales-order-report/view-sales-order",
    component: <SalesOrderView />,
    module: "Reports Screen",
    type: "RealtimeInventory-View",
    protected: true,
  },
  {
    key: "RealtimeInventory-View",
    route: "/realtime-inventory/view",
    component: <RealtimeInventoryView />,
    module: "Reports Screen",
    protected: true,
  },
  {
    type: "OutstandingBalance-View",
    key: "OutstandingBalance-View",
    route: "/outstanding-Balance/view",
    module: "Reports Screen",
    component: <OutstandingBalanceView />,
    protected: true,
  },
];

export default routes;
